module.exports = __webpack_public_path__ + "static/img/8.fc457ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/8.png
// module id = OET/
// module chunks = 0